export default "__VITE_ASSET__CTxGPtiE__"